import {
  Box,
  Checkbox,
  Grid,
  Paper,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { useFormikContext } from 'formik';
import React from 'react';
import { NewCentralFormType } from '../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '8px 0',
    },
    inputField: {
      marginRight: 16,
    },
  })
);

type Props = {};

export const getArchivalUnitFilterInitVals = () => {
  return {};
};

export const fulltextSearchActive = (values: NewCentralFormType): boolean =>
  values.specificFilterRows.some((r) => r.filterOption.filterType === 'FTX');

function SearchFiltersArchivalUnits(props: Props) {
  const classes = useStyles();
  const { handleChange, values } = useFormikContext<NewCentralFormType>();
  if (
    !values.includeSearchEntityTypes.ARCHIVAL_UNIT_OR_EAD ||
    !fulltextSearchActive(values)
  ) {
    return null;
  }
  return (
    <Grid item xs={12}>
      <Paper style={{ padding: 16 }}>
        Upřesňující filtry pro fulltextové vyhledávání
        <Box display="flex">
          <Box className={classes.inputField}>
            <Checkbox
              id="archivalUnitsFilters.metadata"
              checked={values.archivalUnitsFilters.metadata}
              value={values.archivalUnitsFilters.metadata}
              onChange={handleChange}
            />
            Archivní popis
          </Box>
          {/* <Box className={classes.inputField}>
            <Checkbox
              id="archivalUnitsFilters.obsah"
              checked={values.archivalUnitsFilters.obsah}
              value={values.archivalUnitsFilters.obsah}
              onChange={handleChange}
            />
            Regest / obsah
          </Box> */}
          <Box className={classes.inputField}>
            <Checkbox
              id="archivalUnitsFilters.digital"
              checked={values.archivalUnitsFilters.digital}
              value={values.archivalUnitsFilters.digital}
              onChange={handleChange}
            />
            Digitální obsah
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
}

export default SearchFiltersArchivalUnits;
